export default function TS_Null() {
  return (
    <div>
      <h1>TS Null</h1>
      <p>This is the TS Null page.</p>
    </div>
  );
}